import z from 'zod';
import { languageSchema } from '@app/schemas/language';

export const colorSchema = z.string().regex(/^#([0-9A-Fa-f]{6})$/, {
  message: 'Invalid color format. Use hex format, e.g., #33AABB',
});

z.globalRegistry.add(colorSchema, { id: 'color' });

export type ColorSchema = z.infer<typeof colorSchema>;

export const colorOrTransparentSchema = z.union([
  colorSchema,
  z.literal('transparent'),
]);

z.globalRegistry.add(colorOrTransparentSchema, { id: 'color-or-transparent' });

export type ColorOrTransparentSchema = z.infer<typeof colorOrTransparentSchema>;

export const colorTranslatableSchema = z.object({
  fallback: languageSchema,
  translations: z.record(languageSchema, colorSchema),
});

z.globalRegistry.add(colorTranslatableSchema, { id: 'color-translatable' });

export type ColorTranslatableSchema = z.infer<typeof colorTranslatableSchema>;

export const colorActivatableTranslatableSchema = z.object({
  normal: colorTranslatableSchema,
  active: colorTranslatableSchema.optional(),
});

z.globalRegistry.add(colorActivatableTranslatableSchema, { id: 'color-activatable-translatable' });

export type ColorActivatableTranslatableSchema = z.infer<typeof colorActivatableTranslatableSchema>;
